import type { ReduxApplicationState } from '../combinedReducer';

export const selectProductReviews = (state: ReduxApplicationState) => state.reviews;

/**
 * Whether the client-fetched fields belong to the product the page is showing. They do not
 * on the first render after a client-side navigation: the props deep-merge has replaced the
 * product but left the previous product's fields, and the effect that resets them has not
 * run yet. Reading them through this keeps that render from showing the wrong product.
 */
const isForCurrentProduct = (state: ReduxApplicationState) =>
  state.reviews.productCode === state.product.code;

// The summary selectors are the data layer's read API for the ReviewsSummary
// component (DISC-4325's split, consumed from DISC-4326).
export const selectAiSummary = (state: ReduxApplicationState) => state.reviews.aiSummary;

export const selectProductInsights = (state: ReduxApplicationState) =>
  isForCurrentProduct(state) ? state.reviews.productInsights : undefined;

export const selectRatingBreakdown = (state: ReduxApplicationState) =>
  isForCurrentProduct(state) ? state.reviews.ratingBreakdown : undefined;

/** The rar-data-api list's own average, the fallback when Feefo has not settled. */
export const selectListAverageRating = (state: ReduxApplicationState) =>
  isForCurrentProduct(state) ? state.reviews.averageProductRating : null;
